import React from 'react';

function HeaderCellIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			fill='none'
			viewBox='0 0 16 16'
		>
			<path
				fill='#EDF876'
				d='M12 2a2 2 0 012 2v2h-3a1 1 0 01-1-1V3a1 1 0 011-1h1zM12 14a2 2 0 110-4 2 2 0 010 4zM4 14a2 2 0 110-4 2 2 0 010 4zM4 6a2 2 0 110-4 2 2 0 010 4z'
			></path>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M13.405 13.406c-.928.927-2.42.927-5.406.927-2.986 0-4.479 0-5.406-.927-.928-.928-.928-2.42-.928-5.406 0-2.986 0-4.478.928-5.406.927-.927 2.42-.927 5.406-.927 2.985 0 4.478 0 5.406.927.927.928.927 2.42.927 5.406 0 2.986 0 4.478-.928 5.406z'
			></path>
			<path
				stroke='#141414'
				d='M6 14.333V1.667M10 14.333V1.667M14.332 6H1.665M14.332 10H1.665'
			></path>
		</svg>
	);
}

export default HeaderCellIcon;
